(function () {
  document.querySelectorAll('[data-catalog-card]').forEach((card) => {
    const images = Array.from(card.querySelectorAll('[data-catalog-image]'));
    const bars = Array.from(card.querySelectorAll('[data-catalog-bar]'));
    if (images.length < 2) return;
    let index = 0;

    function show(next) {
      index = (next + images.length) % images.length;
      images.forEach((img, i) => {
        img.classList.toggle('is-hidden', i !== index);
      });
      bars.forEach((bar, i) => {
        bar.classList.toggle('catalog-product-bar--active', i === index);
        bar.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
    }

    card.querySelector('[data-catalog-prev]')?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      show(index - 1);
    });
    card.querySelector('[data-catalog-next]')?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      show(index + 1);
    });
    bars.forEach((bar, i) => {
      bar.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        show(i);
      });
    });
  });

  const page = document.querySelector('[data-catalog-page]');
  if (!page) return;

  const layout = page.querySelector('[data-catalog-layout]');
  const filterPanel = page.querySelector('[data-catalog-filter-panel]');
  const sortPanel = page.querySelector('[data-catalog-sort-panel]');
  const countEl = page.querySelector('[data-catalog-filter-count]');
  const items = Array.from(page.querySelectorAll('[data-catalog-item]'));
  const gridEl = page.querySelector('[data-catalog-grid]');
  const filterEmptyEl = page.querySelector('[data-catalog-filter-empty]');
  const paginationEl = page.querySelector('[data-catalog-pagination]');
  const filterForm = page.querySelector('[data-catalog-filter-form]');
  const clearUrl = filterPanel?.getAttribute('data-clear-url') || window.location.pathname;
  const CLIENT_FILTER_KEY = 'mandiraCatalogClientFilters';
  const CLOSE_GRACE_MS = 350;
  let ignoreOutsideUntil = 0;

  function armOutsideCloseGrace() {
    ignoreOutsideUntil = Date.now() + CLOSE_GRACE_MS;
  }

  let filterBackdrop = null;

  function ensureFilterBackdrop() {
    if (filterBackdrop) return filterBackdrop;
    filterBackdrop = document.createElement('button');
    filterBackdrop.type = 'button';
    filterBackdrop.className = 'catalog-filter-backdrop';
    filterBackdrop.setAttribute('aria-label', 'Close filters');
    filterBackdrop.addEventListener('click', (event) => {
      event.preventDefault();
      setFilterOpen(false);
    });
    return filterBackdrop;
  }

  function closeMenus(except) {
    page.querySelectorAll('[data-catalog-menu-toggle]').forEach((btn) => {
      const key = btn.getAttribute('data-catalog-menu-toggle');
      if (key === except) return;
      btn.setAttribute('aria-expanded', 'false');
    });
    if (except !== 'filter' && filterPanel) {
      filterPanel.hidden = true;
      layout?.classList.remove('catalog-layout--filter-open');
      document.documentElement.classList.remove('catalog-filter-open');
      filterBackdrop?.remove();
    }
    if (except !== 'sort' && sortPanel) {
      sortPanel.hidden = true;
    }
  }

  function setFilterOpen(open) {
    if (!filterPanel || !layout) return;
    filterPanel.hidden = !open;
    layout.classList.toggle('catalog-layout--filter-open', open);
    document.documentElement.classList.toggle('catalog-filter-open', open);
    const btn = page.querySelector('[data-catalog-menu-toggle="filter"]');
    btn?.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      const backdrop = ensureFilterBackdrop();
      if (!backdrop.isConnected) document.body.appendChild(backdrop);
      armOutsideCloseGrace();
    } else {
      filterBackdrop?.remove();
    }
  }

  function setSortOpen(open) {
    if (!sortPanel) return;
    sortPanel.hidden = !open;
    const btn = page.querySelector('[data-catalog-menu-toggle="sort"]');
    btn?.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) armOutsideCloseGrace();
  }

  page.querySelectorAll('[data-catalog-menu-toggle]').forEach((btn) => {
    btn.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const key = btn.getAttribute('data-catalog-menu-toggle');
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      closeMenus(key);
      if (key === 'filter') setFilterOpen(!expanded);
      if (key === 'sort') setSortOpen(!expanded);
    });
  });

  page.querySelectorAll('[data-catalog-filter-close]').forEach((btn) => {
    btn.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      setFilterOpen(false);
    });
  });

  document.addEventListener('click', (event) => {
    if (Date.now() < ignoreOutsideUntil) return;
    if (!page.contains(event.target)) return;
    if (
      event.target.closest(
        '[data-catalog-menu], [data-catalog-filter-panel], [data-catalog-sort-panel], .catalog-toolbar',
      )
    ) {
      return;
    }
    /* Mobile dim overlay is ::before on layout — treat layout chrome clicks as outside */
    closeMenus();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeMenus();
  });

  function selectedValues(selector) {
    return Array.from(page.querySelectorAll(selector + ':checked')).map((input) =>
      (input.value || '').trim().toLowerCase(),
    );
  }

  function setFilterEmpty(empty) {
    if (filterEmptyEl) filterEmptyEl.hidden = !empty;
    if (gridEl) gridEl.hidden = empty;
    if (paginationEl) paginationEl.hidden = empty;
  }

  function readClientFilterState() {
    return {
      sizes: selectedValues('[data-filter-size][data-filter-client]'),
      colours: selectedValues('[data-filter-colour][data-filter-client]'),
      tags: selectedValues('[data-filter-tag][data-filter-client]'),
      products: selectedValues('[data-filter-product][data-filter-client]'),
    };
  }

  function applyClientFilters(state) {
    const sizes = state?.sizes || selectedValues('[data-filter-size]');
    const colours = state?.colours || selectedValues('[data-filter-colour]');
    const tags = state?.tags || selectedValues('[data-filter-tag]');
    const products = state?.products || selectedValues('[data-filter-product]');
    const hasActive =
      sizes.length + colours.length + tags.length + products.length > 0;
    let visible = 0;

    items.forEach((item) => {
      const itemSizes = (item.getAttribute('data-sizes') || '')
        .split(',')
        .map((v) => v.trim().toLowerCase())
        .filter(Boolean);
      const itemColours = (item.getAttribute('data-colours') || '')
        .split(',')
        .map((v) => v.trim().toLowerCase())
        .filter(Boolean);
      const itemTags = (item.getAttribute('data-tags') || '')
        .split(',')
        .map((v) => v.trim().toLowerCase())
        .filter(Boolean);
      const itemType = (item.getAttribute('data-product-type') || '').trim().toLowerCase();

      const sizeOk = !sizes.length || sizes.some((size) => itemSizes.includes(size));
      const colourOk =
        !colours.length || colours.some((colour) => itemColours.includes(colour));
      const tagOk =
        !tags.length ||
        tags.some((tag) => itemTags.some((entry) => entry.includes(tag) || tag.includes(entry)));
      const productOk =
        !products.length ||
        products.some(
          (type) =>
            itemType === type ||
            itemType.includes(type) ||
            itemTags.some((entry) => entry.includes(type) || type.includes(entry)),
        );

      const show = sizeOk && colourOk && tagOk && productOk;
      item.hidden = !show;
      if (show) visible += 1;
    });

    if (countEl && hasActive) {
      countEl.textContent = visible + (visible === 1 ? ' Product' : ' Products');
    }

    setFilterEmpty(hasActive && visible === 0);
    return visible;
  }

  function collectStorefrontParams() {
    const params = new URLSearchParams();
    if (!filterForm) return params;

    Array.from(filterForm.elements).forEach((el) => {
      if (!el.name || el.disabled) return;
      if (el.hasAttribute('data-filter-client')) return;
      if (el.type === 'checkbox' || el.type === 'radio') {
        if (!el.checked) return;
        params.append(el.name, el.value);
        return;
      }
      if (el.type === 'hidden' || el.type === 'number' || el.type === 'text') {
        const value = String(el.value || '').trim();
        if (!value) return;
        params.set(el.name, value);
      }
    });

    return params;
  }

  function applyFilters() {
    const clientState = readClientFilterState();
    const storefrontParams = collectStorefrontParams();
    const hasStorefront = Array.from(storefrontParams.keys()).some((key) => key.startsWith('filter.'));
    const hasClient =
      clientState.sizes.length +
        clientState.colours.length +
        clientState.tags.length +
        clientState.products.length >
      0;

    if (hasStorefront) {
      try {
        if (hasClient) sessionStorage.setItem(CLIENT_FILTER_KEY, JSON.stringify(clientState));
        else sessionStorage.removeItem(CLIENT_FILTER_KEY);
      } catch (error) {
        /* ignore */
      }
      const query = storefrontParams.toString();
      window.location.href = (filterForm?.action || window.location.pathname) + (query ? '?' + query : '');
      return;
    }

    try {
      sessionStorage.removeItem(CLIENT_FILTER_KEY);
    } catch (error) {
      /* ignore */
    }
    applyClientFilters(clientState);
    setFilterOpen(false);
  }

  function clearFilters(event) {
    if (event?.currentTarget?.tagName === 'A') return;
    event?.preventDefault?.();
    try {
      sessionStorage.removeItem(CLIENT_FILTER_KEY);
    } catch (error) {
      /* ignore */
    }
    window.location.href = clearUrl;
  }

  page.querySelector('[data-catalog-filter-apply]')?.addEventListener('click', (event) => {
    event.preventDefault();
    applyFilters();
  });

  page.querySelectorAll('[data-catalog-filter-clear]').forEach((btn) => {
    btn.addEventListener('click', clearFilters);
  });

  const filterGroups = Array.from(page.querySelectorAll('.catalog-filter-group'));
  filterGroups.forEach((group) => {
    group.addEventListener('toggle', () => {
      if (!group.open) return;
      filterGroups.forEach((other) => {
        if (other !== group) other.open = false;
      });
    });
  });

  /* When filter list hits top/bottom, continue wheel scroll on the page */
  if (filterForm) {
    let pageScrollPending = 0;
    let pageScrollRaf = 0;

    function flushPageScroll() {
      pageScrollRaf = 0;
      const dy = pageScrollPending;
      pageScrollPending = 0;
      if (!dy) return;
      const scroller = document.scrollingElement || document.documentElement;
      scroller.scrollTop += dy;
    }

    filterForm.addEventListener(
      'wheel',
      (event) => {
        const el = filterForm;
        let dy = event.deltaY;
        if (!dy) return;
        if (event.deltaMode === 1) dy *= 16;
        else if (event.deltaMode === 2) dy *= el.clientHeight;

        const maxScroll = Math.max(0, el.scrollHeight - el.clientHeight);
        const atTop = el.scrollTop <= 0;
        const atBottom = el.scrollTop >= maxScroll - 0.5;
        const chain = (dy > 0 && atBottom) || (dy < 0 && atTop);
        if (!chain) return;

        event.preventDefault();
        pageScrollPending += dy;
        if (!pageScrollRaf) {
          pageScrollRaf = requestAnimationFrame(flushPageScroll);
        }
      },
      { passive: false },
    );
  }

  /* Restore client-only filters after a storefront reload */
  try {
    const raw = sessionStorage.getItem(CLIENT_FILTER_KEY);
    if (!raw) return;
    const saved = JSON.parse(raw);
    sessionStorage.removeItem(CLIENT_FILTER_KEY);

    const map = [
      ['[data-filter-size][data-filter-client]', saved.sizes],
      ['[data-filter-colour][data-filter-client]', saved.colours],
      ['[data-filter-tag][data-filter-client]', saved.tags],
      ['[data-filter-product][data-filter-client]', saved.products],
    ];

    map.forEach(([selector, values]) => {
      if (!values?.length) return;
      page.querySelectorAll(selector).forEach((input) => {
        const value = (input.value || '').trim().toLowerCase();
        if (values.includes(value)) input.checked = true;
      });
    });

    applyClientFilters(saved);
  } catch (error) {
    /* ignore */
  }
})();
